var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-changer"},[_c('v-switch',{staticClass:"theme-changer-switch",attrs:{"label":"Classic Theme"},on:{"click":function($event){_vm.theme ? _vm.changeTheme(_vm.themes[1].id) : _vm.changeTheme(_vm.themes[0].id)}},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }